export default __webpack_public_path__ + "static/media/wmd.40602cc2.jpeg";